import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./DataTable.css";
import { IconButton } from "@mui/material";
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';

const DataTablePagination = ({
  height,
  columns,
  rows,
  rowSelection,
  isRowSelectable,
  suppressRowClickSelection,
  onRowSelected,
  gridOptions,
  onGridReady,
  onSelectionChanged,
  headerCheckboxSelectionFilterOnly,
  isCellCheckboxSelection,
  onFirstDataRendered,
  ref,
  selectionColumnDef,
  getRowStyle,
  getRowId,
  cellEditorParams,
  stopEditingWhenCellsLoseFocus,
  onCellValueChanged,
  onFilterChanged,
  postFilterChanged,
  suppressMenuHide,
  goToPage,
  pageSize,
  currentPage,
  totalPages,
  onPageSizeChanged,
  totalPageItems,
  totalItemCurrentPage,
  defaultColDef,
  filteredTotalColumn,
  enableCharts,
  cellSelection,
  pmSourceModalOpen,
  getContextMenuItems
}) => {

  // const startItem = (currentPage - 1) * pageSize + 1;
  const startItem = totalPageItems > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(currentPage * pageSize, totalPageItems);
  return (
    <div
      className="ag-theme-quartz"
      style={{ height: height || 600, width: "auto" }}
    >
      <AgGridReact
        ref={ref}
        rowData={rows}
        columnDefs={columns}
        rowSelection={rowSelection || "multiple"}
        isRowSelectable={isRowSelectable}
        suppressRowClickSelection={suppressRowClickSelection || true}
        moveColumns={false}
        suppressDragLeaveHidesColumns={true}
        // suppressMovable={false}
        onRowSelected={onRowSelected}
        undoRedoCellEditing={true} // Enable undo/redo for cell editing
        gridOptions={gridOptions}
        onGridReady={onGridReady}
        onSelectionChanged={onSelectionChanged}
        headerCheckboxSelectionFilterOnly={headerCheckboxSelectionFilterOnly}
        isCellCheckboxSelection={isCellCheckboxSelection}
        onFirstDataRendered={onFirstDataRendered}
        selectionColumnDef={selectionColumnDef}
        getRowStyle={getRowStyle}
        getRowId={getRowId}
        cellEditorParams={cellEditorParams}
        stopEditingWhenCellsLoseFocus={stopEditingWhenCellsLoseFocus || true}
        onCellValueChanged={onCellValueChanged}
        onFilterChanged={onFilterChanged}
        postFilterChanged={postFilterChanged}
        suppressMenuHide={suppressMenuHide}
        defaultColDef={defaultColDef}
        suppressRowTransform={true}
        enableRangeSelection={true} // Enable range selection
        enableFillHandle={true} // Enable drag fill/copy
        // enableCellTextSelection={true}
        enableCharts={enableCharts || false}
        cellSelection={cellSelection}
        getContextMenuItems={getContextMenuItems}
      />
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
        {
          pmSourceModalOpen === true ?  
          <div style={{display: 'flex'}}>
              <p style={{margin: '5px'}}>Page Size:</p>
              {
              filteredTotalColumn === 0 ?
              <select onChange={onPageSizeChanged} value={pageSize === totalPageItems ? "all" : pageSize} style={{ width: '70px', borderRadius: '5px', borderColor: 'lightgray', padding: '5px' }}>
                  <option value={'all'}>All</option>
                  <option value={2000}>2000</option>
                  <option value={3500}>3500</option>
                  <option value={5000}>5000</option>
              </select> 
              :
              <select onChange={onPageSizeChanged} value={pageSize} style={{ width: '70px', borderRadius: '5px', borderColor: 'lightgray', padding: '5px' }}>
                <option value={3500}>3500</option>
            </select>
              }
          </div>
          :
        <div style={{display: 'flex'}}>
            <p style={{margin: '5px'}}>Page Size:</p>
            {
            filteredTotalColumn === 0 ?
            <select onChange={onPageSizeChanged} value={pageSize} style={{ width: '70px', borderRadius: '5px', borderColor: 'lightgray', padding: '5px' }}>
                <option value={totalPageItems}>All</option>
                <option value={2000}>2000</option>
                <option value={3500}>3500</option>
                <option value={5000}>5000</option>
            </select> 
            :
            <select onChange={onPageSizeChanged} value={pageSize} style={{ width: '70px', borderRadius: '5px', borderColor: 'lightgray', padding: '5px' }}>
              <option value={3500}>3500</option>
          </select>
            }
        </div>
        }
        <div style={{margin: '0 25px'}}>
            <span>{`${startItem} to ${endItem} of ${totalPageItems}`}</span>
        </div>
        <div>
            <IconButton onClick={() => goToPage(1)} disabled={currentPage === 1} style={{padding: 0}}>
                <SkipPreviousIcon />
            </IconButton>
            <IconButton onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                <ArrowLeftIcon />
            </IconButton>
            <span>{`Page ${currentPage} of ${filteredTotalColumn === 0 ? totalPages : '1'}`}</span>
            <IconButton onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages || filteredTotalColumn > 0}>
                <ArrowRightIcon />
            </IconButton>
            <IconButton onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages || filteredTotalColumn > 0} style={{padding: 0}}>
                <SkipNextIcon />
            </IconButton>
        </div>
      </div>
    </div>
  );
};
export default DataTablePagination;
